import type { StatusTransMap } from "components/table";
import type { FeedbackCounts, FeedbackStatus } from "types/feedback";
import type { BadgeTone } from "views/Opportunity/opportunity.meta";

export const FEEDBACK_PATH = "/feedback";

export const feedbackStatusTrans: StatusTransMap<FeedbackStatus> = {
  PENDING: { label: "Chưa xử lý", color: "#b54708", bgcolor: "#fdead7" },
  DONE: { label: "Đã xử lý", color: "#027a48", bgcolor: "#d1fadf" },
};

export const feedbackStatusOptions: { label: string; value: FeedbackStatus }[] = [
  { label: "Chưa xử lý", value: "PENDING" },
  { label: "Đã xử lý", value: "DONE" },
];

export const feedbackTabs: { key: string; label: string; tone: BadgeTone }[] = [
  { key: "ALL", label: "Tất cả", tone: "blue" },
  { key: "PENDING", label: "Chưa xử lý", tone: "orange" },
  { key: "DONE", label: "Đã xử lý", tone: "green" },
];

export const emptyFeedbackCounts = (): FeedbackCounts => ({
  all: 0,
  statuses: { PENDING: 0, DONE: 0 },
});

export const staffName = (staff?: { name?: string; username?: string } | null) =>
  staff?.name || staff?.username || "--";
